import React from "react";
import clsx from "clsx";
import { useTranslation } from "next-i18next";
import { useTouchState } from "@/hooks/common/useTouchState";
import AudioPlayer, { AudioType } from "../AudioPlayer";

import styles from "./SystemFeedback.module.scss";

interface IProps {
    onClose: () => void;
    playAudioEffect?: boolean;
}

const MarketClosedFeedback: React.FC<IProps> = ({ onClose, playAudioEffect = true }) => {
    const { t } = useTranslation("common");
    const { isTouched, onTouchStart, onTouchEnd } = useTouchState();

    return (
        <>
            {playAudioEffect && <AudioPlayer type={AudioType.ERROR} />}
            <div className={clsx(styles.container, styles.marketClosed)}>
                <div className={clsx(styles.icon, styles.clockClosedIcon)} />

                <div className={styles.title}>{t("messages.132")}</div>

                <div className={styles.description}>{t("check_out_info_tab")}</div>

                <div className={styles.btnContainer}>
                    <button
                        className={clsx(styles.btn, {
                            [styles.touched]: isTouched
                        })}
                        onClick={onClose}
                        onTouchStart={onTouchStart}
                        onTouchEnd={onTouchEnd}
                    >
                        {t("close")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default React.memo(MarketClosedFeedback);
